module.exports = __webpack_public_path__ + "img/BJÖRKHAGE.2a9a85c2.jpg";